import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  apiUrl2 = `${environment.API_URL2}/clients` ;
  apiUrl3 = `${environment.API_URL2}/client` ;

  constructor(private http : HttpClient) { }

  create(params){
    return this.http.post(`${this.apiUrl2}/crt/`,params);
  }
  update(params){
    return this.http.post(`${this.apiUrl2}/upd/`,params);
  }

  getClients(){
    return this.http.get(`${this.apiUrl2}/getClients`);
  }
  getClientsCW(user_id){
    return this.http.get(`${this.apiUrl2}/gtClientsCW/${user_id}`);
  }

  // Old get client by user id
  // getActiveClientsCW(user_id){
  //   return this.http.get(`${this.apiUrl2}/gtActiveClientsCW/${user_id}`);
  // }

  // New get client by user id
  getActiveClientsCW(user_id){
    return this.http.get(`${this.apiUrl2}/gtActiveClientsCW/${user_id}`);
  }

  getClientById(id){
    return this.http.get(`${this.apiUrl2}/getClientById/${id}`);
  }

  delete(id){
    return this.http.delete(`${this.apiUrl2}/dlt/${id}`);
  }
  
  createClientModuleMapping(params){
    return this.http.post(`${this.apiUrl3}/createClientModuleMapping/`,params);
  }
  getClientModuleMappingById(id){
    return this.http.get(`${this.apiUrl3}/getClientModuleMappingById/${id}`);
  }
  getClientModuleMapping(){
    return this.http.get(`${this.apiUrl3}/getClientModuleMapping`);
  }
  getClientModuleMappingByClientId(id){
    return this.http.get(`${this.apiUrl3}/getClientModuleMappingByClientId/${id}`);
  }
  updateClientModuleMapping(params){
    return this.http.post(`${this.apiUrl3}/updateClientModuleMapping/`,params);
  }
}
